import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { PostHogProvider } from '@posthog/react';
import { HelmetProvider } from 'react-helmet-async';
// redux
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';

import App from './app';
import { store, persistor } from './redux/store';
import { posthog, initPostHog } from './utils/posthog';

// ----------------------------------------------------------------------

// Initialize PostHog before render (no-op when REACT_APP_POSTHOG_KEY is unset).
initPostHog();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <PostHogProvider client={posthog}>
            <Suspense>
              <App />
            </Suspense>
          </PostHogProvider>
        </BrowserRouter>
      </PersistGate>
    </ReduxProvider>
  </HelmetProvider>
);
